module.exports = __webpack_public_path__ + "img/accumulated_train_number.74912e3e.png";